/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'outline/16/delete-lightblue': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="none" _stroke="#2270AD" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M2.5 5.5v8a2 2 0 002 2h7a2 2 0 002-2v-8M1.5 3.5h13M5.5 3.5v-3h5v3"/><path pid="1" data-color="color-2" d="M5.5 12.5l5-5M10.5 12.5l-5-5"/></g>'
  }
})
